import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import Header from './Header';
import Content from './Content';
import {ComingSoonModal} from '../components/ComingSoonModal'
import { useConfig } from '../contexts/ConfigContext';

const OUTLET_EXCEPTS = ['/login','/policy/share'];

function Layouts(props) {
  const { children } = props;
  const { pathname = '/' } = useLocation();
  const { clientId } = useConfig();

  const memoNodes = useMemo(() => {
    const nodes = OUTLET_EXCEPTS?.includes(pathname) ? (
      <>{children}</>
    ) : (
        <div className={`h-screen shadow-lg ${clientId === 'client-b' ? 'mainContainer' : 'bg-base-200'}`}>
            {process.env.REACT_APP_TYPE !== 'grid-build' && <Header/>}
            <Content>
              <div className={clientId === 'client-b' ? 'mainContainer' : 'bg-base-200'}>
                {/* <div className='bg-base-200 lg:mx-4 contentContainer'> */}
                  {children}
                </div>
            </Content>
            <ComingSoonModal/>
        </div>
    );

    return nodes;
  }, [children, pathname]);

  return <>{memoNodes}</>;
}

export default Layouts;
